<template>
  <div class="container">
    <div v-if="!display_image" class="art" v-bind:style="{width:art_width+'px',height:art_height+'px',left:art_left+'px'}"></div>
    <img v-if="display_image" class="art" v-bind:style="{width:art_width+'px',height:art_height+'px',left:art_left+'px'}" v-bind:class="{art_circle:circle}" v-bind:src="src">

    <!--   <svg v-if="figure=='woman'" class="figure" id="woman"  v-bind:height="figure_height+'px'" viewBox="0 0 76 176" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
          <g transform="matrix(0.550589,0,0,0.550589,0.333333,0.333333)">
              <g transform="matrix(1,0,0,1,-353.407,-593.158)">
                  <path d="M454.136,625.744C454.136,643.741 439.547,658.33 421.55,658.33C403.554,658.33 388.964,643.741 388.964,625.744C388.964,607.748 403.554,593.158 421.55,593.158C439.547,593.158 454.136,607.748 454.136,625.744Z" class="shape"  />
              </g>
              <g transform="matrix(1,0,0,1,-353.407,-593.158)">
                  <path d="M381.415,757.767L381.415,706.336C381.415,705.062 382.448,704.028 383.724,704.028C384.998,704.028 386.031,705.062 386.031,706.336L386.031,745.952L381.415,757.767ZM459.451,704.028L459.452,704.028C460.727,704.028 461.76,705.062 461.76,706.336L461.76,758.91L457.144,747.095L457.144,706.336C457.144,705.062 458.178,704.028 459.451,704.028ZM489.321,829.458L471.342,783.437C479.039,776.7 483.947,766.858 483.947,755.825L483.947,703.073C483.947,682.763 467.483,666.299 447.173,666.299L395.556,666.299C375.245,666.299 358.781,682.763 358.781,703.073L358.781,755.825C358.781,766.858 363.692,776.697 371.389,783.435L353.407,829.458L386.031,829.458L386.031,893.678C386.031,902.781 393.045,910.719 402.145,910.992C411.559,911.275 419.28,903.727 419.28,894.376L419.28,829.458L423.896,829.458L423.896,893.678C423.896,902.781 430.91,910.719 440.008,910.992C449.423,911.275 457.144,903.727 457.144,894.376L457.144,829.458L489.321,829.458Z"
                     class="shape" />
              </g>
          </g>
      </svg>
      <svg v-if="figure=='man'" id="man" v-bind:height="figure_height+'px'" viewBox="0 0 72 181" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
          <g transform="matrix(0.56632,0,0,0.56632,0.333333,0.333333)">
              <g transform="matrix(1,0,0,1,-495.729,-211)">
                  <path d="M584.122,284.141L532.504,284.141C512.193,284.141 495.729,300.605 495.729,320.915L495.729,373.667C495.729,387.212 503.057,399.042 513.961,405.421C515.908,406.56 518.364,405.18 518.364,402.924L518.364,324.178C518.364,322.904 519.396,321.871 520.672,321.871C521.945,321.871 522.979,322.904 522.979,324.178L522.979,511.521C522.979,520.623 529.994,528.561 539.093,528.834C548.508,529.117 556.229,521.569 556.229,512.218L556.229,417.161C556.229,415.887 557.262,414.854 558.536,414.854C559.812,414.854 560.844,415.887 560.844,417.161L560.844,511.521C560.844,520.624 567.858,528.561 576.957,528.834C586.371,529.117 594.093,521.569 594.093,512.218L594.093,324.178C594.093,322.904 595.126,321.871 596.4,321.871C597.676,321.871 598.708,322.904 598.708,324.178L598.709,402.652C598.709,404.923 601.198,406.309 603.141,405.132C613.781,398.69 620.896,387.014 620.896,373.667L620.896,320.915C620.896,300.605 604.432,284.141 584.122,284.141Z"
                      class="shape" />
              </g>
              <g transform="matrix(1,0,0,1,-495.729,-211)">
                  <path d="M591.084,243.586C591.084,261.582 576.495,276.171 558.499,276.171C540.502,276.171 525.913,261.582 525.913,243.586C525.913,225.589 540.502,211 558.499,211C576.495,211 591.084,225.589 591.084,243.586Z" class="shape"/>
              </g>
          </g>
      </svg>-->
  <!--  <img v-if="figure=='rudolf'" src="/static/home/rudolf_II_figure_bw.png" v-bind:height="figure_height+'px'" class="figure" v-bind:style="{'margin-top':(figure_height<art_height)?art_height-figure_height+'px':0}">-->
   <img v-if="figure=='rudolf'" src="/static/home/rudolf_II_fig.png" v-bind:height="figure_height+'px'" class="figure" v-bind:style="{'margin-top':(figure_height<art_height)?art_height-figure_height+'px':0}">

  </div>
</template>

<script>
  export default {
    name: 'TheManAndArt',
    props: ['width', 'height', 'diameter', 'unit', 'figure_height', 'figure', 'display_image', 'src', 'circle'],
    data() {
      return {
        // figure_height:18,
        // art_width: 10,
        //   art_height: 11,
       // art_left: 0
      }
    },
    computed: {
      art_width: function() {
        var rat = this.figure_height / 170;
        if (this.unit == 'mm') {
          rat = rat * 0.1;
        }
        return this.width * rat;
      },
      art_height: function() {
        var rat = this.figure_height / 170;
        if (this.unit == 'mm') {
          rat = rat * 0.1;
        }
        return this.height * rat;
      },
      art_left: function() {
        var rat = this.figure_height / 170;
        if (this.unit == 'mm') {
          rat = rat * 0.1;
        }
        return this.figure_height * 0.66 + 5 * rat;;
      },
    },
    methods: {

    },
    mounted() {
      /*    if (this.figure == 'woman') {
            var rat = this.figure_height / 185;
            this.art_left = this.figure_height * 0.428;
          }
          else if (this.figure == 'man') {
            var rat = this.figure_height / 180;
            this.art_left = this.figure_height * 0.394;
          }
          else 
      {
        var rat = this.figure_height / 170;
        this.art_left = this.figure_height * 0.66;
      }

      if (this.unit == 'mm') {
        rat = rat * 0.1;
      }
      this.art_left += 5 * rat;
      this.art_width = this.width * rat;
      this.art_height = this.height * rat;*/
    }
  }
</script>

<style scoped>
  .container {
    position: relative;


  }

  .art {
    position: absolute;
    border: 2px solid #808080;
    /* border: 3px solid #DAA520*/
  }

  .art_circle {
    position: absolute;
    border: 2px solid #808080;
    border-radius: 50%;
  }

  .shape {
    fill: none;
    fill-rule: nonzero;
    stroke: #595959;

    stroke-width: 2px;
  }

  .figure {}
</style>



// WEBPACK FOOTER //
// src/components/TheManAndArt.vue